"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
const react_1 = __importDefault(require("react"));
const Accordion_elements_1 = require("./Accordion.elements");
const accordion_arrow_svg_1 = __importDefault(require("@components/icons/accordion-arrow.svg"));
const classnames_1 = __importDefault(require("classnames"));
const Accordion = ({ title, isFramed = false, children, open, hasExercises, isUseCustomStyle, }) => {
    return (react_1.default.createElement(Accordion_elements_1.AccordionWrap, { className: (0, classnames_1.default)(isFramed ? 'framed' : 'default', { exercises: hasExercises }), open: open },
        react_1.default.createElement("summary", null,
            react_1.default.createElement("span", null, title),
            react_1.default.createElement(accordion_arrow_svg_1.default, null)),
        react_1.default.createElement(Accordion_elements_1.AccordionContent, { className: isUseCustomStyle ? 'custom-exercise' : hasExercises ? 'exercises' : 'default' }, children)));
};
exports.Accordion = Accordion;
